

import axios from 'axios';
import * as bootstrap from 'bootstrap';
import MarkdownIt from "markdown-it";
import * as Vue from "vue";
import * as utils from "./utils";
import {
  and,
  apiAxios, calcularImpuesto, calculateTax, exportTableToExcel, extractTax, extraerImpuesto,
  firstOf,
  float,
  formatCurrency, getById,
  goToURL, hideMessage,
  int,
  intcomma,
  is,
  notifyMe,
  orderBy,
  parseErrors, showMessage, showModal,
  str,
  translate
} from "./utils";
import vars from "./vars";
import DocumentFormApp from "./vue/document-app/document-app";

// jquery
import $ from 'jquery';
(window as any).$ = $;
(window as any).jQuery = $;


declare global {
  interface Window {
    [key: string]: any;
  }
}


window.addEventListener("load", () => {

  /**
   * Manejo de submit de formularios para evitar doble submit
   */
  document.addEventListener("submit", (e) => {
    const form = e.target as HTMLFormElement;
    if (!form) return;

    // Evita doble submit
    if ((form as any)._submitting) {
      e.preventDefault();
      return;
    }

    (form as any)._submitting = true;

    // Deshabilita todos los submit buttons
    const buttons = form.querySelectorAll<HTMLButtonElement>(
      'button[type="submit"], input[type="submit"]'
    );

    buttons.forEach(btn => {
      btn.disabled = true;
      btn.dataset.originalText = btn.innerHTML;
      btn.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${btn.innerHTML}`;
    });
  });



  /**
   * Funcionalidad para redimensionar columnas de tablas con clase .table-resize
   */
  let thElm: HTMLTableCellElement | null = null;
  let startOffset = 0;
  const tableHeaders = document.querySelectorAll<HTMLTableCellElement>(".table-resize th");
  tableHeaders.forEach((th) => {
    th.style.position = "relative";
    const grip = document.createElement("div");
    grip.style.position = "absolute";
    grip.style.top = "0";
    grip.style.right = "0";
    grip.style.bottom = "0";
    grip.style.width = "5px";
    grip.style.cursor = "col-resize";
    grip.style.userSelect = "none"; // evita selección de texto
    grip.innerHTML = "&nbsp;";
    grip.addEventListener("mousedown", (e: MouseEvent) => {
      thElm = th;
      startOffset = th.offsetWidth - e.pageX;
      document.body.style.cursor = "col-resize"; // feedback visual
      e.preventDefault();
    });
    th.appendChild(grip);
  });
  // Mientras el usuario mueve el mouse, cambia el ancho de la columna
  document.addEventListener("mousemove", (e: MouseEvent) => {
    if (thElm) {
      const newWidth = startOffset + e.pageX;
      if (newWidth > 30) {
        // ancho mínimo
        thElm.style.width = `${newWidth}px`;
      }
    }
  });
  // Al soltar el botón del mouse, finaliza el ajuste
  document.addEventListener("mouseup", () => {
    if (thElm) {
      thElm = null;
      document.body.style.cursor = "default";
    }
  });
});


async function activeDarkMode() {
  try {
    const res = await utils.apiAxios.get('/conf/setdarkmode/');
    if (res.status === 200) {
      const htmlElement = document.documentElement;

      if (res.data.darkmode === true) {
        htmlElement.setAttribute('data-bs-theme', 'dark');
      } else {
        htmlElement.setAttribute('data-bs-theme', 'light');
      }
    }
  } catch(error) {
    console.error(error);
  }
}


function mountApp(component: any, element: string) {
  const app = Vue.createApp(component);
  app.mount(`${element}`);
  return app;
}


window.unolet = {
  vars,
  utils,
  DocumentFormApp,
  mountApp,
}

window.bootstrap = bootstrap;

const markdown = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
});
window.markdown = markdown;


// TODO: Legacy code. Este codigo es para mantener compatibilidad con el código antiguo que
//       usa variables globales en el objeto window. El objetivo es eliminar este código
//       cuando sea posible, y usar la propiedad `vars` y `utils` para acceder a las necesarias.
window.ENTRADA = vars.ENTRADA;
window.SALIDA = vars.SALIDA;
window.PORCENTAJE = vars.PORCENTAJE;
window.FIJO = vars.FIJO;
window.FACTURA_CONTADO = vars.FACTURA_CONTADO;
window.FACTURA_CREDITO = vars.FACTURA_CREDITO;
window.FACTURAS = vars.FACTURAS;
window.BOOTSTRAP_COLORS = vars.BOOTSTRAP_COLORS;
window.True = vars.True;
window.False = vars.False;
window.None = vars.None;
window.IS_PROCESS_SUBMIT = vars.IS_PROCESS_SUBMIT;

window.activeDarkMode = activeDarkMode;
window.apiAxios = apiAxios;  // Instancia de axios para llamadas a la API interna
window.axios = axios; // Instancia general de axios
window.calcularImpuesto = calcularImpuesto;
window.calculateTax = calculateTax;
window.exportTableToExcel = exportTableToExcel;
window.extractTax = extractTax;
window.extraerImpuesto = extraerImpuesto;
window.formatCurrency = formatCurrency;
window.getById = getById;
window.orderBy = orderBy;
window.goToURL = goToURL;
window.hideMessage = hideMessage;
window.intcomma = intcomma;
window.notifyMe = notifyMe;
window.parseErrors = parseErrors;
window.showMessage = showMessage as any;
window.showModal = showModal as any;
window.translate = translate;
window.float = float;
window.int = int;
window.firstOf = firstOf;
window.is = is;
window.and = and;
window.str = str;
window._ = translate;
// End of legacy code